import { render, staticRenderFns } from "./schoolData.vue?vue&type=template&id=58493e93&scoped=true&"
import script from "./schoolData.vue?vue&type=script&lang=js&"
export * from "./schoolData.vue?vue&type=script&lang=js&"
import style0 from "./schoolData.vue?vue&type=style&index=0&id=58493e93&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58493e93",
  null
  
)

export default component.exports